<script setup lang="ts">
const metrics = [
    {
        value: '40+',
        label: 'Heures économisées',
        description: 'En moyenne par revue',
    },
    {
        value: '100%',
        label: 'Votre travail',
        description: 'Vous gardez toujours le dernier mot',
    },
    {
        value: 'PRISMA',
        label: 'Prêt pour publication',
        description: 'Export conforme aux standards',
    },
];
</script>

<template>
    <section class="border-y border-border/40 py-16">
        <div
            class="mx-auto flex max-w-5xl flex-col items-center gap-10 px-4 md:flex-row md:justify-between md:gap-0"
        >
            <div
                v-for="metric in metrics"
                :key="metric.label"
                class="flex flex-1 flex-col items-center text-center"
            >
                <span
                    class="text-3xl font-semibold tracking-tight text-brand sm:text-4xl"
                >
                    {{ metric.value }}
                </span>
                <span class="mt-2 text-sm font-medium text-foreground">
                    {{ metric.label }}
                </span>
                <span class="mt-1 text-xs text-muted-foreground">
                    {{ metric.description }}
                </span>
            </div>
        </div>
    </section>
</template>
